import { DatePeriodTrackingName } from './analytics.constants';
import { API } from '../../vendor/api';
import { selectAnalyticsFilter, selectAnalyticsDatePeriod, } from './../../store/features/system/selectors';
import { RootScopeEvents } from './../../common/services/root-scope-types';
import { getAngularService, AngularServices } from './../../modules/core';
export const analyticsUsageViewed = (data) => async (dispatch) => {
    const rootScope = getAngularService(AngularServices.RootScope);
    rootScope.$emit(RootScopeEvents.ANALYTICS.USAGE, data);
};
export const analyticsMeetingHistoryViewed = (data) => async (dispatch) => {
    const rootScope = getAngularService(AngularServices.RootScope);
    rootScope.$emit(RootScopeEvents.ANALYTICS.MEETING_HISTORY, data);
};
export const analyticsFilterSelected = ({ page }) => async (dispatch, getState) => {
    const state = getState();
    const filters = selectAnalyticsFilter(state);
    const datePeriod = selectAnalyticsDatePeriod(state);
    let roomType = null;
    let { isPersonal } = (filters.roomsIds.length &&
        (await API.room.findRoomById({ id: filters.roomsIds[0] }))) || {
        isPersonal: null,
    };
    if (filters.roomsIds.length) {
        if (isPersonal) {
            roomType = 'provider room';
        }
        else {
            roomType = 'shared room';
        }
    }
    const data = {
        page,
        provider: filters.providersIds.length > 0,
        room: filters.roomsIds.length > 0,
        location: filters.locationIds.length > 0,
        room_type: roomType,
        date: DatePeriodTrackingName[datePeriod],
    };
    const rootScope = getAngularService(AngularServices.RootScope);
    rootScope.$emit(RootScopeEvents.ANALYTICS.FILTER, data);
};
